// Canonical GS1 plan name (`plans.name`) slugs, mirroring
// srv/src/base/gs1/plans/constants/plan_names.py -- keep both in sync with
// *_seed_gs1_plans_and_dashboards.sql. gs1PlanNames.test.ts pins these
// against that same migration directly (it can't import the Python module),
// so a rename that updates one side and not the other fails a test instead
// of drifting silently.
export const GS1_PLAN_NAME_SMB = 'smbs';
export const GS1_PLAN_NAME_INVENTARIO_INTELIGENTE_SUPPLIER = 'inventario_inteligente_supplier';
export const GS1_PLAN_NAME_INVENTARIO_INTELIGENTE_RETAILER = 'inventario_inteligente_retailer';
